import InfiniteScroll from './infiniteScroll';

export default InfiniteScroll;